export const ACTIVITIES = [
  { icon: '💧', label: 'Hydration' },
  { icon: '🥗', label: 'Healthy Meal' },
  { icon: '🏃', label: 'Exercise' },
  { icon: '🧘', label: 'Meditation' },
  { icon: '📓', label: 'Journaling' },
  { icon: '🙏', label: 'Gratitude' },
  { icon: '👥', label: 'Social' },
  { icon: '🎨', label: 'Creative' },
  { icon: '📚', label: 'Reading' },
  { icon: '🌿', label: 'Nature' },
  { icon: '🎵', label: 'Music' },
  { icon: '🛁', label: 'Self-Care' },
  { icon: '💊', label: 'Medication' },
  { icon: '🍵', label: 'Herbal Tea' },
  { icon: '🌞', label: 'Sunlight' },
];

export const TRIGGERS = [
  { icon: '😤', label: 'Conflict' },
  { icon: '💼', label: 'Work Stress' },
  { icon: '💸', label: 'Financial' },
  { icon: '🏠', label: 'Home Issues' },
  { icon: '😴', label: 'Poor Sleep' },
  { icon: '🍺', label: 'Substances' },
  { icon: '📱', label: 'Social Media' },
  { icon: '🤒', label: 'Physical Pain' },
  { icon: '🧠', label: 'Overthinking' },
  { icon: '👥', label: 'Loneliness' },
  { icon: '📰', label: 'News/Media' },
  { icon: '⏰', label: 'Overwhelm' },
  { icon: '🕯️', label: 'Grief / Loss' },
];

export const STRUGGLES = [
  { icon: '💼', label: 'Work pressure' },
  { icon: '💰', label: 'Financial stress' },
  { icon: '💔', label: 'Relationship issues' },
  { icon: '🏠', label: 'Family challenges' },
  { icon: '🧠', label: 'Mental health' },
  { icon: '🏥', label: 'Health concerns' },
  { icon: '😰', label: 'Self-doubt' },
  { icon: '🌀', label: 'Uncertainty' },
  { icon: '😴', label: 'Exhaustion' },
  { icon: '🎯', label: 'Lack of motivation' },
  { icon: '⏳', label: 'Time management' },
  { icon: '🗣️', label: 'Communication' },
  { icon: '🔒', label: 'Setting boundaries' },
  { icon: '🌙', label: 'Sleep problems' },
  { icon: '🍽️', label: 'Eating habits' },
  { icon: '🏃', label: 'Exercise routine' },
  { icon: '📱', label: 'Screen time' },
  { icon: '🎭', label: 'Feeling fake' },
  { icon: '🧩', label: 'Finding purpose' },
  { icon: '🤝', label: 'Making friends' },
  { icon: '🕯️', label: 'Grief & loss' },
];

export const MOOD_TAGS = [
  '😌 Calm', '😟 Anxious', '😔 Sad', '😊 Happy',
  '🥺 Vulnerable', '😤 Frustrated', '🙏 Grateful', '😩 Overwhelmed',
  '🤩 Energized', '😴 Tired', '🧠 Overthinking', '🌈 Hopeful',
  '😶 Numb', '😡 Angry', '💜 Connected', '🏝️ Lonely',
  '🎉 Excited',
];

export const DAILY_CHALLENGES = [
  { id: 'gratitude', title: 'Gratitude Moment', description: 'Note one thing you\'re grateful for', emoji: '🙏', points: 10 },
  { id: 'hydration', title: 'Stay Hydrated', description: 'Drink a glass of water', emoji: '💧', points: 5 },
  { id: 'deep_breath', title: 'Deep Breath', description: 'Take 3 deep breaths right now', emoji: '🌬️', points: 5 },
  { id: 'stretch', title: 'Quick Stretch', description: 'Stretch your body for 30 seconds', emoji: '🧘', points: 10 },
  { id: 'positive_thought', title: 'Positive Thought', description: 'Think of one positive thing about yourself', emoji: '✨', points: 10 },
  { id: 'nature_moment', title: 'Nature Connection', description: 'Look outside or at a plant for 10 seconds', emoji: '🌿', points: 5 },
  { id: 'smile', title: 'Smile Break', description: 'Smile for 10 seconds (it helps!)', emoji: '😊', points: 5 },
  { id: 'body_scan', title: 'Quick Body Scan', description: 'Notice how each part of your body feels', emoji: '🧍', points: 10 },
];

export const SLEEP_QUALITY_LABELS = ['', 'Poor', 'Fair', 'Okay', 'Good', 'Great'];
